var exports = {
  "kL": "x93eb46d8--e7f6ac--container",
  "VD": "x93eb46d8--e7f6ac--container--mortgage-annotations",
  "UA": "x93eb46d8--e7f6ac--snippet",
  "jW": "x93eb46d8--e7f6ac--photo",
  "qS": "x93eb46d8--e7f6ac--badge",
  "ed": "x93eb46d8--e7f6ac--disclaimer",
  "Qs": "x93eb46d8--e7f6ac--content",
  "Mn": "x93eb46d8--e7f6ac--top",
  "QN": "x93eb46d8--e7f6ac--company",
  "QY": "x93eb46d8--e7f6ac--geo",
  "Fh": "x93eb46d8--e7f6ac--geo-row",
  "hl": "x93eb46d8--e7f6ac--address",
  "PM": "x93eb46d8--e7f6ac--close-block",
  "Ie": "x93eb46d8--e7f6ac--empty",
};

module.exports = exports;
